const {
	InnerBlocks,
} = wp.blockEditor;

export default function( ) {
	return <InnerBlocks.Content />;
}
